
// Define column mappings from Excel to Database
export const COLUMN_MAPPINGS: { [key: string]: string } = {
  'Div': 'Division',
  'Date': 'Date',
  'HomeTeam': 'HomeTeam',
  'AwayTeam': 'AwayTeam',
  'FTHG': 'FTHG',
  'FTAG': 'FTAG',
  'FTR': 'FTR',
  'HTHG': 'HTHG',
  'HTAG': 'HTAG',
  'HTR': 'HTR'
};

// Define all expected columns, including betting columns
export const EXPECTED_COLUMNS = [
  'Division', 'Date', 'Time', 'HomeTeam', 'AwayTeam', 'FTHG', 'FTAG', 'FTR',
  'HTHG', 'HTAG', 'HTR', 'Referee', 'HS', 'AS', 'HST', 'AST', 'HF',
  'AF', 'HC', 'AC', 'HY', 'AY', 'HR', 'AR',
  // Betting odds - pre-match
  'B365H', 'B365D', 'B365A', 'BWH', 'BWD', 'BWA', 'IWH', 'IWD', 'IWA',
  'PSH', 'PSD', 'PSA', 'WHH', 'WHD', 'WHA', 'VCH', 'VCD', 'VCA',
  'BSH', 'BSD', 'BSA', 'GBH', 'GBD', 'GBA', 'SJH', 'SJD', 'SJA',
  'LBH', 'LBD', 'LBA', '1XBH', '1XBD', '1XBA',
  'MaxH', 'MaxD', 'MaxA', 'AvgH', 'AvgD', 'AvgA',
  'BFEH', 'BFED', 'BFEA',
  // Over/under odds
  'B365>2.5', 'B365<2.5', 'P>2.5', 'P<2.5', 'Max>2.5', 'Max<2.5', 'Avg>2.5', 'Avg<2.5', 'BFE>2.5', 'BFE<2.5',
  // Asian handicap
  'AHh', 'B365AHH', 'B365AHA', 'PAHH', 'PAHA', 'MaxAHH', 'MaxAHA', 'AvgAHH', 'AvgAHA', 'BFEAHH', 'BFEAHA',
  // Closing odds
  'B365CH', 'B365CD', 'B365CA', 'BWCH', 'BWCD', 'BWCA', 'IWCH', 'IWCD', 'IWCA',
  'PSCH', 'PSCD', 'PSCA', 'WHCH', 'WHCD', 'WHCA', 'VCCH', 'VCCD', 'VCCA',
  '1XBCH', '1XBCD', '1XBCA', 'MaxCH', 'MaxCD', 'MaxCA', 'AvgCH', 'AvgCD', 'AvgCA',
  'BFECH', 'BFECD', 'BFECA',
  // Closing over/under
  'B365C>2.5', 'B365C<2.5', 'PC>2.5', 'PC<2.5', 'MaxC>2.5', 'MaxC<2.5', 'AvgC>2.5', 'AvgC<2.5', 'BFEC>2.5', 'BFEC<2.5',
  // Closing Asian handicap
  'AHCh', 'B365CAHH', 'B365CAHA', 'PCAHH', 'PCAHA', 'MaxCAHH', 'MaxCAHA', 'AvgCAHH', 'AvgCAHA', 'BFECAHH', 'BFECAHA'
];
